/* ============================================================
   Engraving popup — bogstavfelter i en popup + add to cart
   Bogstaverne sendes som line item properties via produktformularen
   (inputs har form="..."-attributten og ligger i popuppen).
   ============================================================ */

class EngravingPopup extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('x-modal');
    if (!this.modal) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    // x-modal flyttes til <body> når den åbnes, så events lyttes på selve modalen
    this.modal.addEventListener('input', (event) => this.onInput(event), { signal });
    this.modal.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

    // Luk popuppen ved klik på add to cart (når felterne er gyldige, ellers forbliver den åben så fejlen ses)
    const form = document.forms[this.dataset.form];
    form?.addEventListener('submit', () => {
      if (form.checkValidity()) {
        this.modal.hide();
      }
    }, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  get inputs() {
    return Array.from(this.modal.querySelectorAll('.engraving-popup__input'));
  }

  /**
   * Samler bogstaverne til én note på ordrelinjen, fx "1:A 2:B 3:C 4:D". Tomme felter springes over
   * (og er noten helt tom, tilføjer Shopify ingen note)
   */
  updateNote() {
    const note = this.inputs
      .filter((input) => input.value)
      .map((input) => `${input.dataset.label}:${input.value}`)
      .join(' ');

    this.modal.querySelector('.engraving-popup__value').value = note;
  }

  onInput(event) {
    const input = event.target;
    if (!input.classList?.contains('engraving-popup__input')) return;

    // Kun ét tegn pr. felt (det senest indtastede, så et bogstav nemt kan skiftes), altid med stort, og ingen blanke felter.
    // Feltet har maxlength=2, så man kan skrive oven i et eksisterende tegn
    const value = input.value.trim().toUpperCase();
    input.value = value ? Array.from(value).pop() : '';

    this.updateNote();

    // Hop automatisk videre til næste felt
    if (input.value) {
      const inputs = this.inputs;
      inputs[inputs.indexOf(input) + 1]?.focus();
    }
  }

  onKeydown(event) {
    const input = event.target;
    if (!input.classList?.contains('engraving-popup__input')) return;

    const inputs = this.inputs;
    const index = inputs.indexOf(input);

    if (event.key === 'Backspace' && !input.value) {
      inputs[index - 1]?.focus();
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      inputs[index - 1]?.focus();
    } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      inputs[index + 1]?.focus();
    }
  }
}

if (!window.customElements.get('engraving-popup')) {
  window.customElements.define('engraving-popup', EngravingPopup);
}
